import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import Loder from "./Loder";
import { CartContext } from "../Contexts/CartContextProvider";
import { useContext } from "react";
import style from "../styles/SingleProduct.module.css";
import { Navigate, useNavigate } from "react-router-dom";
function SingleProduct() {
  // export const cartProducts = [...cartItems];
  const navigate = useNavigate();
  const { PID } = useParams();

  const { cartItems, setcartItems } = useContext(CartContext);

  const [Loading, setLoading] = useState(false);
  const [Product, setProduct] = useState({});
  // const [cartItems, setCartUtems] = useState([]);
  const getData = () => {
    return axios
      .get(`https://infinite-digitals.onrender.com/computers/${PID}`)
      .then((res) => res.data);
  };

  const fetchAndUpadateData = async () => {
    try {
      setLoading(true);
      const data = await getData();
      setProduct(data);
      setLoading(false);
    } catch (error) {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchAndUpadateData();
  }, []);

  const Add_to_Cart = () => {
    setcartItems([...cartItems, { ...Product, qty: 1 }]);
  };

  if (Loading) {
    return <Loder />;
  }

  console.log(Product);
  const { id, name, img, mrp, price, discount } = Product;
  return (
    <>
      <div className={style.chechout_empty}></div>
      <div className={style.main_cont_check}>
        <div className={style.image_cont}>
          <img src={img} alt={`product with id ${id}`} />
        </div>
        <div className={style.info_cont}>
          <div className={style.article_ID}>
            <p>Article ID: {id}</p>
            <h3>{name}</h3>
          </div>
          <div className={style.sub_info}>
            <div className={style.sub_info_tc}>
              <h4>Gain more with offers (4)</h4>
              <ul>
                <li>
                  Wall mount bracket is on chargeable basis.{" "}
                  <span className={style.tc_color_blue}>Read T&C</span>
                </li>
                <li>
                  Buy RCP warranty and save up to 55%.
                  <span className={style.tc_color_blue}>Read T&C</span>
                </li>
                <li>
                  Shop for Rs.20,000 & above and get instant discount Up To
                  Rs.5000,Use coupon codes "YES1000" for above 20,000 ,"YES2500"
                  for above 50,000, "YES5000" for above 1,00,000..
                  <span className={style.tc_color_blue}>Read T&C</span>
                </li>
                <li>
                  Get Cashback upto Rs. 1,000 on Mobikwik Wallet.{" "}
                  <span className={style.tc_color_blue}>Read T&C</span>
                </li>
              </ul>
              <h4>Save more with EMI/Cashback (1)</h4>
              <ul>
                <li>
                  EMIs (Credit Cards) from ₹792.16/month |{" "}
                  <span className={style.tc_color_blue}>View all</span> Standard
                  Credit Cards EMI options
                </li>
              </ul>
              <h4>Warranty</h4>
              <ul>
                <li>
                  <strong>Warranty:</strong> 1 Year manufacturer warranty
                </li>
              </ul>
              <h3>
                Additional Services & Warranties (3)
                <span className={style.tc_color_blue}> View Plans</span>
              </h3>
            </div>
            <div className={style.sub_info_buttons}>
              <h1 className={style.price_heading}>{`₹${price}`}</h1>
              <span className={style.mrp_cont}>
                MRP : <strike> {mrp}</strike>
              </span>{" "}
              <span>(Inclusive of all taxes)</span>
              <p style={{ color: "green", fontWeight: "700" }}>You save:</p>
              <h4>
                EMIs (Credit Cards) from ₹792.16/month |
                <span className={style.tc_color_blue}> View Plans</span>
              </h4>
              <h2>FREE Shipping!</h2>
              <input
                className={style.cupan_input}
                type="text"
                placeholder="Enter / Detect PIN Code"
              />
              <div className={style.BTNS_cont}>
                <button
                  onClick={() => {
                    Add_to_Cart();
                    navigate("/cart");
                  }}
                  className={style.cart_BTN}
                >
                  ADD TO CART
                </button>
                <button className={style.cart_BTN}>Add To Wishlist</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default SingleProduct;
